/**
 * 队列：先进先出
 */
export class Queue<T> {
  private queue: Array<T>;

  constructor() {
    this.queue = new Array<T>();
  }

  /**
   * 清空队列
   */
  public clear() {
    this.queue = new Array<T>();
  }

  /**
   * 检查是否是空队列
   * @returns 是否是空队列
   */
  public isEmpty(): boolean {
    return !this.queue.length || this.queue.length === 0;
  }

  /**
   * 获取第一个元素，但是不从队列中移除。
   * @returns 第一个元素
   */
  public peek(): T | null {
    const len = this.size();
    if (len > 0) {
      return this.queue[0];
    }
    return null;
  }

  /**
   * 打印队列
   */
  public print(): void {
    console.log(this.queue.toString());
  }

  /**
   * 返回队列的第一个对象，不存在则返回null
   * @returns 第一个对象
   */
  public shift(): T | null {
    const data = this.queue.shift();
    if (!data) {
      return null;
    }
    return data;
  }

  /**
   * 将对象加入到队列
   * @param item 加入队列的对象
   */
  public push(item: T) {
    this.queue.push(item);
  }

  /**
   * 获取队列的大小
   * @returns 队列的大小
   */
  public size(): number {
    return this.queue.length;
  }
}
